import { connect } from 'react-redux';

import PreviewReport from './PreviewReport.js';

const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return {
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    server: activeServer,
  };
};

const ConnectedPreviewReport = connect(
  mapStateToProps,
  null
)(PreviewReport);

export default ConnectedPreviewReport;
